import ReportedHolrModal from './ReportedHolrModal';

export default ReportedHolrModal;
